import { render, staticRenderFns } from "./EColorSubtitled.vue?vue&type=template&id=5b008e22&scoped=true&"
import script from "./EColorSubtitled.vue?vue&type=script&lang=js&"
export * from "./EColorSubtitled.vue?vue&type=script&lang=js&"
import style0 from "./EColorSubtitled.vue?vue&type=style&index=0&id=5b008e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b008e22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b008e22')) {
      api.createRecord('5b008e22', component.options)
    } else {
      api.reload('5b008e22', component.options)
    }
    module.hot.accept("./EColorSubtitled.vue?vue&type=template&id=5b008e22&scoped=true&", function () {
      api.rerender('5b008e22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/EColorSubtitled.vue"
export default component.exports